import * as React from 'react';
import {CardObject} from "../../../../types.d";
import {useState} from "react";
import {VocabularyModal} from "../../../partials/modals/VocabularyModal";
import {approvedText, escalationText} from "../../../../utils/approvedText";

export interface VocabularyThumbProps {
    card: CardObject;
}

export const VocabularyThumb = (props: VocabularyThumbProps) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { card } = props;

    return <div className="card m-2 card-data-preview vocabulary-card-view">
        <div className="card-body">
            <p className="card-modal-header">
                <strong>{ card.wordTranslation.sourceWord.lemma } -&gt; { card.wordTranslation.translationWord.lemma }</strong><br />
                <em>{ card.course.sourceLanguage.code } -&gt; { card.course.translationLanguage.code }</em>
            </p>
            <p>
                <strong>Creator:</strong> { card.creatorName }<br />
                <strong>Approving:</strong> { card.approvingName }
                &nbsp;{ approvedText(card.approvedAt, card.disapprovedAt) }<br />
                <strong>Escalating:</strong> { card.escalatingName }
                &nbsp;{ escalationText(card) }
                </p>
        </div>
        <div className="d-flex justify-content-between card-footer">
            <a href="" className="btn btn-sm btn-primary" onClick={e => {
                e.preventDefault();
                setModalVisible(true);
            }}>View Card Details</a>
        </div>

        <VocabularyModal card={card} visible={modalVisible} toggle={() => setModalVisible(!modalVisible)}/>
    </div>
};
